'use strict';

import { Entity } from '../Entity';
import { App } from '../App';

export class IndAppAlternateId extends Entity {
  protected id;
  protected indId;
  protected app: App;
  protected contactId;
  protected listId;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;
    if (data.app) {
      const app = new App();
      app.hydrate(data.app);

      this.app = app;
    }
    this.contactId = data.contactId;
    this.listId = data.listId;
  }

  public getId() {
    return this.id;
  }

  public getIndId() {
    return this.indId;
  }

  public getApp() {
    return this.app;
  }

  public getContactId() {
    return this.contactId;
  }

  public getListId() {
    return this.listId;
  }
}
